import React from "react";

const Card = ({
  children,
  title,
  subtitle,
  headerAction,
  variant = "default",
  padding = "md",
  className = "",
}) => {
  const variants = {
    default: "bg-white border border-gray-200",
    elevated: "bg-white shadow-lg",
    flat: "bg-gray-50",
  };

  const paddings = {
    none: "",
    sm: "p-4",
    md: "p-6",
    lg: "p-8",
  };

  return (
    <div className={`rounded-lg ${variants[variant]} ${className}`}>
      {(title || subtitle || headerAction) && (
        <div className={`${paddings[padding]} border-b border-gray-200`}>
          <div className="flex justify-between items-start">
            <div>
              {title && (
                <h3 className="text-lg font-bold text-gray-900">{title}</h3>
              )}
              {subtitle && (
                <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
              )}
            </div>
            {headerAction && <div>{headerAction}</div>}
          </div>
        </div>
      )}
      <div
        className={
          title || subtitle ? paddings[padding] : `${paddings[padding]}`
        }
      >
        {children}
      </div>
    </div>
  );
};

export default Card;
